import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { CheckCircle, XCircle, FileText, User, Building, CreditCard } from 'lucide-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import NavBar from '../../component/b2c/navBar/navBar';
import Sidebar from '../../component/b2c/sidebar/sidebar';
import { useMyContext } from '../../context/MyContext';
import { Base_Url, userlist, userdocApprove, Url_For_View_Document, deleteuser } from '../../config/config';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { useAuth } from '../../routes/Auth';
import { FaEye } from 'react-icons/fa'
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ViewAllCustomerModel from '../../component/b2c/models/ViewAllCustomerModel'

const KYCPending = () => {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const { isToggleSidebar, isDarkMode } = useMyContext();
  const [customers, setCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryByName, SearchQueryByName] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [selectedApproval, setSelectedApproval] = useState({});
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCustomers, setTotalCustomers] = useState();
  const [limit, setLimit] = useState(10);
  const role = localStorage.getItem('role');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [originalTotalCustomers, setOriginalTotalCustomers] = useState(0);

  const navigate = useNavigate();

  const goTobankReq = () => {
    navigate("/allReqForBankdoc")
  }
  useEffect(() => {
    getDocumentList();
  }, [currentPage, limit]);


  const getDocumentList = async () => {
    const url = `${Base_Url}admin/${userlist}?page=${currentPage}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        const filteredCustomers = data.data.filter(customer => customer.role !== 'admin');
        const adminCount = data.data.filter(customer => customer.role === 'admin').length;
        const adjustedTotal = data.pagination.totalItems - adminCount;
        setCustomers(filteredCustomers);
        setTotalCustomers(adjustedTotal)
        setOriginalTotalCustomers(adjustedTotal);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  const handlePaginationChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setCurrentPage(1);
  };

  const handleRadioChange = (customerId, documentType, status) => {
    setSelectedApproval((prev) => ({
      ...prev,
      [customerId]: {
        ...prev[customerId],
        [documentType]: status
      }
    }));
  };

  const hasAnyRadioSelection = (customer) => {
    const customerSelections = selectedApproval[customer.id] || {};

    const hasPendingAadhar = customer.user_address_image && customer.aadhar_status === "0";
    const hasPendingPan = customer.user_pancard_image && customer.pan_card_status === "0";
    const hasPendingGst = customer.user_gst_image && customer.gst_status === "0";

    const hasAadharSelection = hasPendingAadhar && customerSelections.address;
    const hasPanSelection = hasPendingPan && customerSelections.pancard;
    const hasGstSelection = hasPendingGst && customerSelections.gstin;

    return hasAadharSelection || hasPanSelection || hasGstSelection;
  };

  const shouldShowSubmitButton = (customer) => {
    const allApproved =
      customer.aadhar_status === "1" &&
      customer.pan_card_status === "1" &&
      customer.gst_status === "1";

    const allRejected =
      customer.aadhar_status === "2" &&
      customer.pan_card_status === "2" &&
      customer.gst_status === "2";

    const noDocuments =
      !customer.user_address_image &&
      !customer.user_pancard_image &&
      !customer.user_gst_image;

    return !allApproved && !allRejected && !noDocuments && hasAnyRadioSelection(customer);
  };

  const handleSubmit = async (customerId) => {
    const customer = customers.find(c => c.id === customerId);
    const hasAadharDoc = customer?.user_address_image;
    const hasPanDoc = customer?.user_pancard_image;
    const hasGstDoc = customer?.user_gst_image;
    const aadharStatus = customer?.aadhar_status;
    const panStatus = customer?.pan_card_status;
    const gstStatus = customer?.gst_status;

    const selectedAadhar = selectedApproval[customerId]?.address;
    const selectedPan = selectedApproval[customerId]?.pancard;
    const selectedGst = selectedApproval[customerId]?.gstin;

    const missingSelections = [];

    if (hasAadharDoc && aadharStatus !== "1" && !selectedAadhar) {
      missingSelections.push("Aadhaar");
    }
    if (hasPanDoc && panStatus !== "1" && !selectedPan) {
      missingSelections.push("PAN Card");
    }
    if (hasGstDoc && gstStatus !== "1" && !selectedGst) {
      missingSelections.push("GSTIN");
    }
    if (missingSelections.length > 0) {
      toast.error(
        `Please select approval or reject status for: ${missingSelections.join(", ")}`
      );
      return;
    }
    try {
      setLoading((prev) => ({ ...prev, [customerId]: true }));
      const approvalData = {
        customer_id: customerId,
        aadhar_status: aadharStatus === "1" ? "1" : selectedApproval[customerId]?.address,
        pancard_status: panStatus === "1" ? "1" : selectedApproval[customerId]?.pancard,
        gst_status: gstStatus === "1" ? "1" : selectedApproval[customerId]?.gstin,
      };

      const response = await axios.post(
        `${Base_Url}admin/${userdocApprove}`,
        approvalData,
        {
          headers: {
            token: token,
            cus_id: cus_id,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === true) {
        toast.success("Documents Updated Successfully!");
        getDocumentList();
      } else {
        toast.error(`Error: ${response.data.message}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    } finally {
      setLoading((prev) => ({ ...prev, [customerId]: false }));
    }
  };
  const handleDocumentClick = (url) => {
    if (!isAuthenticated) {
      window.location.href = '/dashboard';
    } else {
      window.open(url, '_blank');
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    if (!/^\d{0,12}$/.test(value)) {
      return;
    }
    setSearchQuery(value);
    setCurrentPage(1);
    if (value.length === 12) {
      const filtered = customers.filter((customer) =>
        customer.aadhar_number?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCustomers(filtered);
      setTotalCustomers(filtered.length);
    } else if (value === "") {
      setFilteredCustomers([]);
      setTotalCustomers(originalTotalCustomers);
    }
  };


  useEffect(() => {
    let filtered = customers;

    if (searchQuery.trim() !== '') {
      filtered = filtered.filter(customer =>
        customer.aadhar_number?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (searchQueryByName.trim() !== '') {
      filtered = filtered.filter(customer =>
        customer.name?.toLowerCase().includes(searchQueryByName.toLowerCase())
      );
    }

    setFilteredCustomers(filtered);
  }, [searchQuery, searchQueryByName, customers]);


  const handleSearchChangeByName = (event) => {
    const value = event.target.value;
    SearchQueryByName(value);
    setCurrentPage(1);

    if (value.length > 0) {
      const filtered = customers.filter((customer) =>
        customer.name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCustomers(filtered);
      setTotalCustomers(filtered.length);
    } else if (value === "") {
      setFilteredCustomers([]);
      setTotalCustomers(originalTotalCustomers);
    }
  };
  const handleClick = (customer) => {
    setSelectedCustomer(customer);
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleDelete = async (customer) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this deletion!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#000000',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const urldelete = Base_Url + deleteuser;
        try {
          const token = localStorage.getItem('token');
          const cusid = localStorage.getItem('cus_id');
          const data = {
            retailer_id: customer.id
          };
          const response = await axios.post(urldelete, data, {
            headers: {
              token,
              cus_id: cusid,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
          });

          if (response.data.status === "SUCCESS") {
            getDocumentList();
            Swal.fire(
              'Deleted!',
              response.data.message || 'Reatiler has been deleted successfully.',
              'success'
            );
          } else {
            Swal.fire(
              'Error!',
              'Unexpected response format: ' + response.data.message,
              'error'
            );
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'Error deleting Retailer: ' + error.message,
            'error'
          );
        }
      }
    });
  };

  const docStatusBlock = (status, customerId, field) => {
    if (status === "1") {
      return <CheckCircle className="text-black dark:text-white w-3.5 h-3.5" />;
    }
    if (status === "2") {
      return <XCircle className="text-gray-400 w-3.5 h-3.5" />;
    }
    return (
      <div className="flex items-center gap-1.5 text-[9px]">
        <label className="flex items-center gap-0.5 cursor-pointer">
          <input
            type="radio"
            name={`approval-${customerId}-${field}`}
            value="1"
            checked={selectedApproval[customerId]?.[field] === "1"}
            onChange={() => handleRadioChange(customerId, field, "1")}
            className="accent-black dark:accent-white w-3 h-3"
          />
          Approve
        </label>
        <label className="flex items-center gap-0.5 cursor-pointer">
          <input
            type="radio"
            name={`approval-${customerId}-${field}`}
            value="2"
            checked={selectedApproval[customerId]?.[field] === "2"}
            onChange={() => handleRadioChange(customerId, field, "2")}
            className="accent-black dark:accent-white w-3 h-3"
          />
          Reject
        </label>
      </div>
    );
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
      <div className="z-10">
        <NavBar />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className="fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800"
            style={window.innerWidth < 768 ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' } : {}}>
            <Sidebar />
          </div>
        )}
        <div className="flex-1 dark:bg-black p-3 md:p-4 w-full bg-gray-100 overflow-hidden flex flex-col">
          <div className="max-w-7xl mx-auto w-full flex flex-col h-full">

            {/* Header - Fixed */}
            <div className="flex-shrink-0">
              <div className="flex items-center gap-2 mb-3">
                <div className="p-1.5 rounded border border-gray-300 dark:border-gray-700">
                  <FileText size={14} className="text-gray-600 dark:text-gray-400" />
                </div>
                <div>
                  <h1 className="text-sm font-bold text-gray-800 dark:text-white">KYC Verification</h1>
                  <p className="text-[9px] text-gray-400 dark:text-gray-500">Verify customer documents for KYC compliance</p>
                </div>
              </div>
            </div>

            {/* Search & Button - Fixed */}
            <div className="flex-shrink-0 mb-3">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search by Aadhaar..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="w-full pl-7 pr-2 py-1.5 text-[10px] rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-800 dark:text-white focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 transition-all"
                  />
                  <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 w-3.5 h-3.5" />
                </div>

                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search by Name..."
                    value={searchQueryByName}
                    onChange={handleSearchChangeByName}
                    className="w-full pl-7 pr-2 py-1.5 text-[10px] rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-800 dark:text-white focus:outline-none focus:ring-1 focus:ring-gray-500 dark:focus:ring-gray-400 transition-all"
                  />
                  <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 w-3.5 h-3.5" />
                </div>

                <button
                  className="w-full py-1.5 px-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-black text-gray-700 dark:text-gray-300 text-[10px] font-medium hover:bg-gray-100 dark:hover:bg-gray-800 transition-all flex items-center justify-center gap-1.5"
                  onClick={goTobankReq}
                >
                  <Building size={12} /> Bank Document Requests
                </button>
              </div>
            </div>

            {/* Cards Grid - Scrollable */}
            <div className="flex-1 overflow-y-auto custom-scrollbar">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 pb-3">
                {(searchQuery.trim().length === 12 && filteredCustomers.length === 0) ? (
                  <div className="col-span-full text-center text-gray-400 text-[11px] py-8">
                    No customers found with this Aadhaar number.
                  </div>
                ) : (
                  (searchQueryByName.trim().length > 0 && filteredCustomers.length === 0) ? (
                    <div className="col-span-full text-center text-gray-400 text-[11px] py-8">
                      No customers found with this Name.
                    </div>
                  ) : (
                    (filteredCustomers.length > 0 ? filteredCustomers : customers).map((customer) => (
                      <div key={customer.id} className="bg-white dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg overflow-hidden p-3 flex flex-col shadow-sm hover:shadow-md transition-shadow">
                        
                        {/* Header */}
                        <div className="border-b border-gray-100 dark:border-gray-800 pb-2 mb-2 flex justify-between items-center">
                          <h2 className="text-[11px] font-semibold text-gray-800 dark:text-white flex items-center gap-1.5 truncate max-w-[150px]">
                            <User className="w-3.5 h-3.5 text-gray-500 dark:text-gray-400 flex-shrink-0" />
                            {customer.name}
                          </h2>
                          <div className="flex items-center gap-1.5 flex-shrink-0">
                            <button
                              className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                              onClick={() => handleClick(customer)}
                            >
                              <FaEye className="w-3.5 h-3.5 text-gray-500 dark:text-gray-400" />
                            </button>
                            <button
                              className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
                              onClick={() => handleDelete(customer)}
                            >
                              <MdDeleteForever className="w-4 h-4 text-red-500" />
                            </button>
                          </div>
                        </div>

                        {/* Company */}
                        <div className="flex items-center gap-1.5 mb-2">
                          <Building className="w-3.5 h-3.5 text-gray-400 dark:text-gray-500 flex-shrink-0" />
                          <span className="text-[9px] text-gray-500 dark:text-gray-400">Company:</span>
                          <span className="text-[9px] text-gray-700 dark:text-gray-300 truncate">{customer.company_type || 'N/A'}</span>
                        </div>

                        {/* ID Info - Now in Columns */}
                        <div className="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-2 mb-2">
                          <div className="flex items-center gap-1.5 mb-1.5">
                            <CreditCard className="w-3.5 h-3.5 text-gray-400 dark:text-gray-500" />
                            <span className="text-[9px] font-medium text-gray-500 dark:text-gray-400">ID Details</span>
                          </div>
                          <div className="grid grid-cols-3 gap-2">
                            <div className="bg-white dark:bg-black/50 rounded px-1.5 py-1 border border-gray-200 dark:border-gray-700">
                              <div className="text-[8px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">GST</div>
                              <div className="text-[9px] text-gray-700 dark:text-gray-300 font-mono truncate">{customer.gst_number || 'N/A'}</div>
                            </div>
                            <div className="bg-white dark:bg-black/50 rounded px-1.5 py-1 border border-gray-200 dark:border-gray-700">
                              <div className="text-[8px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">Aadhaar</div>
                              <div className="text-[9px] text-gray-700 dark:text-gray-300 font-mono truncate">{customer.aadhar_number || 'N/A'}</div>
                            </div>
                            <div className="bg-white dark:bg-black/50 rounded px-1.5 py-1 border border-gray-200 dark:border-gray-700">
                              <div className="text-[8px] text-gray-400 dark:text-gray-500 uppercase tracking-wider">PAN</div>
                              <div className="text-[9px] text-gray-700 dark:text-gray-300 font-mono truncate">{customer.pancard_number || 'N/A'}</div>
                            </div>
                          </div>
                        </div>

                        {/* Documents */}
                        <div className="space-y-1 mb-2">
                          <div className="flex items-center gap-1.5 mb-0.5">
                            <FileText className="w-3.5 h-3.5 text-gray-400 dark:text-gray-500" />
                            <span className="text-[9px] font-medium text-gray-500 dark:text-gray-400">Documents</span>
                          </div>
                          {customer.user_address_image && (
                            <div className="flex items-center justify-between py-0.5 px-1.5 rounded hover:bg-gray-50 dark:hover:bg-gray-900/50">
                              <span className="text-[9px] text-gray-600 dark:text-gray-400">Aadhaar</span>
                              <div className="flex items-center gap-2">
                                <button
                                  className="text-[9px] text-gray-500 dark:text-gray-400 underline hover:text-gray-800 dark:hover:text-white transition-colors"
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_address_image)}
                                >
                                  View
                                </button>
                                {docStatusBlock(customer.aadhar_status, customer.id, 'address')}
                              </div>
                            </div>
                          )}
                          {customer.user_pancard_image && (
                            <div className="flex items-center justify-between py-0.5 px-1.5 rounded hover:bg-gray-50 dark:hover:bg-gray-900/50">
                              <span className="text-[9px] text-gray-600 dark:text-gray-400">PAN</span>
                              <div className="flex items-center gap-2">
                                <button
                                  className="text-[9px] text-gray-500 dark:text-gray-400 underline hover:text-gray-800 dark:hover:text-white transition-colors"
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_pancard_image)}
                                >
                                  View
                                </button>
                                {docStatusBlock(customer.pan_card_status, customer.id, 'pancard')}
                              </div>
                            </div>
                          )}
                          {customer.user_gst_image && (
                            <div className="flex items-center justify-between py-0.5 px-1.5 rounded hover:bg-gray-50 dark:hover:bg-gray-900/50">
                              <span className="text-[9px] text-gray-600 dark:text-gray-400">GST</span>
                              <div className="flex items-center gap-2">
                                <button
                                  className="text-[9px] text-gray-500 dark:text-gray-400 underline hover:text-gray-800 dark:hover:text-white transition-colors"
                                  onClick={() => handleDocumentClick(Url_For_View_Document + customer.user_gst_image)}
                                >
                                  View
                                </button>
                                {docStatusBlock(customer.gst_status, customer.id, 'gstin')}
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Submit Button */}
                        <div className="mt-auto pt-1 border-t border-gray-100 dark:border-gray-800">
                          {customer.aadhar_status === "1" &&
                            customer.pan_card_status === "1" &&
                            customer.gst_status === "1" ? (
                            <div className="text-center py-1.5 text-[10px] font-medium text-white cursor-pointer dark:text-green-400 border border-green-200 dark:border-green-800 rounded-lg bg-emerald-500 dark:bg-green-900/20">
                              ✓ Verified
                            </div>
                          ) : customer.aadhar_status === "2" &&
                            customer.pan_card_status === "2" &&
                            customer.gst_status === "2" ? (
                            <div className="text-center py-1.5 text-[10px] font-medium text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-700 rounded-lg">
                              ✕ Rejected
                            </div>
                          ) : !customer.user_address_image &&
                            !customer.user_pancard_image &&
                            !customer.user_gst_image ? (
                            <div className="text-center py-1.5 text-[9px] text-gray-400 dark:text-gray-500">
                              Upload documents to verify
                            </div>
                          ) : shouldShowSubmitButton(customer) ? (
                            <button
                              className="w-full py-1.5 text-[10px] font-medium bg-gray-800 dark:bg-white text-white dark:text-gray-800 rounded-lg hover:opacity-80 transition-all disabled:opacity-50"
                              onClick={() => handleSubmit(customer.id)}
                              disabled={loading[customer.id]}
                            >
                              {loading[customer.id] ? "Submitting..." : "Submit"}
                            </button>
                          ) : (
                            <div className="text-center py-1.5 text-[9px] text-gray-400 dark:text-gray-500">
                              Select status to submit
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )
                )}
              </div>
            </div>

            {/* Pagination - Fixed */}
            <div className="flex-shrink-0 mt-3 pt-3 border-t border-gray-200 dark:border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-2">
              <span className="text-[9px] text-gray-500 dark:text-gray-400 font-medium">
                Total: <span className="text-gray-800 dark:text-white font-semibold">{totalCustomers}</span> customers
              </span>
              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className="border border-gray-300 dark:border-gray-700 rounded-lg p-1 text-[9px] bg-white dark:bg-black text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-1 focus:ring-gray-500"
                >
                  {totalCustomers === 0 ? (
                    <option value={0}>0</option>
                  ) : (
                    <>
                      {totalCustomers >= 10 && <option value={10}>10</option>}
                      {totalCustomers >= 15 && <option value={15}>15</option>}
                      {totalCustomers >= 20 && <option value={20}>20</option>}
                      {totalCustomers > 30 && <option value={totalCustomers}>All</option>}
                    </>
                  )}
                </select>
                <Pagination
                  count={Math.ceil(totalCustomers / limit)}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '10px',
                      borderColor: '#d1d5db',
                      color: '#374151',
                      '&.Mui-selected': {
                        backgroundColor: '#000',
                        color: '#fff',
                        borderColor: '#000',
                      },
                    },
                  }}
                />
              </div>
            </div>

            <ViewAllCustomerModel isopen={isPopupOpen} onClose={handleClose} customer={selectedCustomer} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYCPending;